import React, {useEffect, useState} from "react";
import {Alert, Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useUser} from "../../providers/user-context";
import axiosInstance from "../../config/axios-config";
import {formatDateNow} from "../../i18n/date-formatting";

export default function OrderApprovalPermission({lineId, active = true, onStateChange}) {
    const {t, i18n} = useTranslation();
    const {tenantId, userIdentity} = useUser();
    const scope = `${tenantId}:${userIdentity}:${lineId}`;
    const [result, setResult] = useState(null);
    useEffect(() => {
        if (!active || !lineId) return;
        const controller = new AbortController();
        setResult(null);
        axiosInstance.get(`/api/v1/supplier-orders/by-line/${lineId}`, {signal: controller.signal})
            .then(({data}) => { if (!controller.signal.aborted) setResult({scope, order: data, permission: data.partialApprovalPermission}); })
            .catch(error => {
                if (!controller.signal.aborted) setResult({scope, error: error.response?.status !== 404, permission: null});
            });
        return () => controller.abort();
    }, [active, lineId, scope]);
    const current = active && result?.scope === scope ? result : null;
    useEffect(() => { onStateChange?.(current?.order || null); }, [onStateChange, current]);
    if (!active || !lineId) return null;
    return <Box sx={{my: 2}}>
        <Typography variant="subtitle2">{t("CheckoutPartialPermissionTitle")}</Typography>
        {!current ? <Typography role="status">{t("Loading")}</Typography> : current.error
            ? <Alert severity="warning">{t("OrderPartialPermissionLoadFailed")}</Alert>
            : <>
                <Typography>{t(current.permission?.allowed === true ? "OrderPartialPermissionAllowed" : "OrderPartialPermissionRequired")}</Typography>
                <Typography variant="caption">{t("CheckoutPartialPermissionExclusions")}</Typography>
                {current.permission?.recordedAt && <Typography variant="caption" display="block">
                    {t("OrderPartialPermissionRecordedAt")}: {formatDateNow(current.permission.recordedAt, i18n.language, true)}
                </Typography>}
            </>}
    </Box>;
}
